import { useEffect, useState } from "react";
import { Select, message } from "antd";
import { useTranslation } from "react-i18next";

import { MISSING_TRANSLATION } from "../../../i18n";
import {
  filterOperatorOption,
  listOperators,
  operatorName,
} from "../../../../modules/integrations/accounts";
import { Operator } from "@/providers/smarta-accounts/accounts-api-client";

const { Option } = Select;

interface AssigneeFilterProps {
  value?: string | "unassigned" | null;
  onChange: (value: string | "unassigned" | undefined) => void;
  placeholder?: string;
}

const AssigneeFilter = ({
  value,
  onChange,
  placeholder,
}: AssigneeFilterProps) => {
  const { t } = useTranslation();
  const [operators, setOperators] = useState<Operator[]>([]);

  useEffect(() => {
    listOperators()
      .then((data) => setOperators(data))
      .catch(() => {
        setOperators([]);
        message.error("An error occurred");
      });
  }, []);

  return (
    <Select
      id="assignee-filter"
      allowClear
      showSearch
      style={{ width: "100%" }}
      dropdownMatchSelectWidth={false}
      dropdownStyle={{ minWidth: 240 }}
      value={value ?? undefined}
      onChange={(val) => onChange(val)}
      placeholder={placeholder || t("assignee") || MISSING_TRANSLATION}
      filterOption={filterOperatorOption(operators)}
    >
      <Option value="unassigned">
        {t("unassigned") || MISSING_TRANSLATION}
      </Option>
      {operators.map((op) => (
        <Option key={op.id} value={op.id}>
          {operatorName(op)}
        </Option>
      ))}
    </Select>
  );
};

export default AssigneeFilter;
